import "./layoutStyles.scss";

import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { ChargeNotification } from "../components/PermanentNotifications/ChargeNotification/ChargeNotification";
import { SubscriptionNotification } from "../components/PermanentNotifications/SubscriptionNotification/SubscriptionNotification";
import { ScrollToTopButton } from "../components/ScrollToTopButton.tsx/ScrollToTopButton";
import { Sidebar } from "../components/Sidebar/Sidebar";
import { useOrganizationContext } from "../contexts/organizations/organizationsContext";
import { ThemeModeProvider } from "../contexts/theme-mode/ThemeModeProvider";
import { useBilling } from "../hooks/reactQueryHooks/useBilling";
import { AnalyticsGA } from "../utils/AnalyticsGA";
import { Content } from "./components/content";
import { FooterWrapper } from "./components/footer";
import { HeaderWrapper } from "./components/header";

const MasterLayout = () => {
  const {
    organizations,
    currentOrganization,
    isOwner,
    accessAllowed,
    setSubscriptionData,
  } = useOrganizationContext();
  const { data: billingData } = useBilling(currentOrganization?.id || "");

  useEffect(() => {
    if (billingData) {
      setSubscriptionData(billingData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingData]);

  useEffect(() => {
    if (billingData?.provider === "stripe") {
      AnalyticsGA.enableGA();
    }
  }, [billingData?.provider]);

  if (organizations && organizations.length === 0) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <h1>You don&#39;t have any available organizations.</h1>
      </div>
    );
  }
  return (
    organizations && (
      <ThemeModeProvider>
        <div className="d-flex flex-column flex-root app-root">
          {!accessAllowed && <SubscriptionNotification isOwner={isOwner} />}
          {billingData && (
            <ChargeNotification
              organization={currentOrganization?.id || ""}
              isOwner={isOwner}
              data={billingData}
            />
          )}
          <div className="app-page flex-column flex-column-fluid">
            <HeaderWrapper />
            <div className="app-wrapper flex-row-fluid">
              <Sidebar billingData={billingData} />
              <div className="d-flex app-main flex-column flex-row-fluid">
                <div className="d-flex flex-column flex-column-fluid">
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>
        <ScrollToTopButton />
      </ThemeModeProvider>
    )
  );
};

export { MasterLayout };
